export default "__VITE_ASSET__DqUFtiAt__"